module.exports = __webpack_public_path__ + "static/media/google-play-badge6.9d842b07.png";